<template>
  <form @submit.prevent
    class="p-6 bg-white rounded"
  >
    <slot></slot>
  </form>
</template>

<script>
export default {
  name: 'MForm',
};
</script>

<style>

</style>
